var {
  useMessageFormatter
} = require("@react-aria/i18n");

var _spectrumIconsWorkflowMore = $parcel$interopDefault(require("@spectrum-icons/workflow/More"));

var {
  ActionButton
} = require("@react-spectrum/button");

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var {
  useTreeState
} = require("@react-stately/tree");

var {
  useSeparator
} = require("@react-aria/separator");

var {
  Text
} = require("@react-spectrum/text");

var {
  mergeProps,
  useSyncRef,
  filterDOMProps
} = require("@react-aria/utils");

var {
  Grid
} = require("@react-spectrum/layout");

var _spectrumIconsUiCheckmarkMedium = $parcel$interopDefault(require("@spectrum-icons/ui/CheckmarkMedium"));

var {
  useMenuTriggerState
} = require("@react-stately/menu");

var {
  useMenuTrigger,
  useMenuItem,
  useMenuSection,
  useMenu
} = require("@react-aria/menu");

var {
  PressResponder,
  useHover
} = require("@react-aria/interactions");

var {
  Popover,
  Tray
} = require("@react-spectrum/overlays");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  useContext,
  forwardRef,
  Fragment,
  useRef
} = _react2;

var {
  FocusScope,
  FocusRing
} = require("@react-aria/focus");

var {
  DismissButton,
  useOverlayPosition
} = require("@react-aria/overlays");

var {
  classNames,
  unwrapDOMRef,
  useDOMRef,
  useIsMobileDevice,
  useStyleProps,
  ClearSlots,
  SlotProvider,
  useSlotProps
} = require("@react-spectrum/utils");

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

var {
  Item,
  Section
} = require("@react-stately/collections");

exports.Section = Section;
exports.Item = Item;

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

const $edd9ab002cde8b9b98bf7ac7e2372c8e$export$MenuContext = /*#__PURE__*/_react.createContext({});

function $edd9ab002cde8b9b98bf7ac7e2372c8e$export$useMenuContext() {
  return useContext($edd9ab002cde8b9b98bf7ac7e2372c8e$export$MenuContext);
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/menu/vars.css
var $bfbcd6bc836614813c70085787fd$exports = {};
$bfbcd6bc836614813c70085787fd$exports = {
  "spectrum-Menu-popover": "_spectrum-Menu-popover_7c360",
  "spectrum-Menu": "_spectrum-Menu_7c360",
  "spectrum-Menu-sectionHeading": "_spectrum-Menu-sectionHeading_7c360",
  "spectrum-Menu-checkmark": "_spectrum-Menu-checkmark_7c360",
  "spectrum-Menu-item": "_spectrum-Menu-item_7c360",
  "is-selected": "_is-selected_7c360",
  "spectrum-Icon": "_spectrum-Icon_7c360",
  "spectrum-Menu-itemLabel": "_spectrum-Menu-itemLabel_7c360",
  "spectrum-Menu-itemIcon": "_spectrum-Menu-itemIcon_7c360",
  "spectrum-Menu-itemLabel--wrapping": "_spectrum-Menu-itemLabel--wrapping_7c360",
  "spectrum-Menu-divider": "_spectrum-Menu-divider_7c360",
  "spectrum-Menu-itemGrid": "_spectrum-Menu-itemGrid_7c360",
  "is-selectable": "_is-selectable_7c360",
  "spectrum-Menu-end": "_spectrum-Menu-end_7c360",
  "spectrum-Menu-icon": "_spectrum-Menu-icon_7c360",
  "spectrum-Menu-description": "_spectrum-Menu-description_7c360",
  "spectrum-Menu-keyboard": "_spectrum-Menu-keyboard_7c360",
  "focus-ring": "_focus-ring_7c360",
  "is-focused": "_is-focused_7c360",
  "is-hovered": "_is-hovered_7c360",
  "is-highlighted": "_is-highlighted_7c360",
  "is-open": "_is-open_7c360",
  "is-active": "_is-active_7c360",
  "is-disabled": "_is-disabled_7c360"
};
var $bfbcd6bc836614813c70085787fd$$interop$default = $parcel$interopDefault($bfbcd6bc836614813c70085787fd$exports);

function $c4892d994b65f49f4dea95880128b38$var$MenuTrigger(props, ref) {
  let menuPopoverRef = useRef();
  let triggerRef = useRef();
  let domRef = useDOMRef(ref);
  let menuTriggerRef = domRef || triggerRef;
  let menuRef = useRef();
  let {
    children,
    align = 'start',
    shouldFlip = true,
    direction = 'bottom',
    closeOnSelect
  } = props;

  let [menuTrigger, menu] = _react.Children.toArray(children);

  let state = useMenuTriggerState(props);
  let {
    menuTriggerProps,
    menuProps
  } = useMenuTrigger({}, state, menuTriggerRef);
  let initialPlacement;

  switch (direction) {
    case 'left':
    case 'right':
    case 'start':
    case 'end':
      initialPlacement = direction + " " + (align === 'end' ? 'bottom' : 'top');
      break;

    case 'bottom':
    case 'top':
    default:
      initialPlacement = direction + " " + align;
  }

  let isMobile = useIsMobileDevice();
  let {
    overlayProps: positionProps,
    placement
  } = useOverlayPosition({
    targetRef: menuTriggerRef,
    overlayRef: unwrapDOMRef(menuPopoverRef),
    scrollRef: menuRef,
    placement: initialPlacement,
    shouldFlip: shouldFlip,
    isOpen: state.isOpen && !isMobile,
    onClose: state.close
  });

  let menuContext = _babelRuntimeHelpersExtends({}, menuProps, {
    ref: menuRef,
    onClose: state.close,
    closeOnSelect,
    autoFocus: state.focusStrategy || true,
    UNSAFE_style: isMobile ? {
      width: '100%',
      maxHeight: 'inherit'
    } : undefined,
    UNSAFE_className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, {
      'spectrum-Menu-popover': !isMobile
    })
  });

  let contents = /*#__PURE__*/_react.createElement(FocusScope, {
    restoreFocus: true,
    contain: isMobile
  }, /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: state.close
  }), menu, /*#__PURE__*/_react.createElement(DismissButton, {
    onDismiss: state.close
  })); // On small screen devices, the menu is rendered in a tray, otherwise a popover.


  let overlay;

  if (isMobile) {
    overlay = /*#__PURE__*/_react.createElement(Tray, {
      isOpen: state.isOpen,
      onClose: state.close
    }, contents);
  } else {
    overlay = /*#__PURE__*/_react.createElement(Popover, {
      isOpen: state.isOpen,
      UNSAFE_style: positionProps.style,
      ref: menuPopoverRef,
      placement: placement,
      hideArrow: true,
      onClose: state.close,
      shouldCloseOnBlur: true
    }, contents);
  }

  return /*#__PURE__*/_react.createElement(Fragment, null, /*#__PURE__*/_react.createElement(PressResponder, _babelRuntimeHelpersExtends({}, menuTriggerProps, {
    ref: menuTriggerRef,
    isPressed: state.isOpen
  }), menuTrigger), /*#__PURE__*/_react.createElement($edd9ab002cde8b9b98bf7ac7e2372c8e$export$MenuContext.Provider, {
    value: menuContext
  }, overlay));
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */


let MenuTrigger = /*#__PURE__*/forwardRef($c4892d994b65f49f4dea95880128b38$var$MenuTrigger);
exports.MenuTrigger = MenuTrigger;

/** @private */
function $c7f2f7472da9591348da844617ffa5d9$export$MenuItem(props) {
  let {
    item,
    state,
    isVirtualized,
    onAction
  } = props;
  let {
    onClose,
    closeOnSelect
  } = $edd9ab002cde8b9b98bf7ac7e2372c8e$export$useMenuContext();
  let {
    rendered,
    key
  } = item;
  let isSelected = state.selectionManager.isSelected(key);
  let isDisabled = state.disabledKeys.has(key);
  let ref = useRef();
  let {
    menuItemProps,
    labelProps,
    descriptionProps,
    keyboardShortcutProps
  } = useMenuItem({
    isSelected,
    isDisabled,
    'aria-label': item['aria-label'],
    key,
    onClose,
    closeOnSelect,
    isVirtualized,
    onAction
  }, state, ref);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let contents = typeof rendered === 'string' ? /*#__PURE__*/_react.createElement(Text, null, rendered) : rendered;
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("li", _babelRuntimeHelpersExtends({}, mergeProps(menuItemProps, hoverProps), {
    ref: ref,
    className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu-item', {
      'is-disabled': isDisabled,
      'is-selected': isSelected,
      'is-selectable': state.selectionManager.selectionMode !== 'none',
      'is-hovered': isHovered
    })
  }), /*#__PURE__*/_react.createElement(Grid, {
    UNSAFE_className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu-itemGrid')
  }, /*#__PURE__*/_react.createElement(ClearSlots, null, /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      text: _babelRuntimeHelpersExtends({
        UNSAFE_className: $bfbcd6bc836614813c70085787fd$$interop$default['spectrum-Menu-itemLabel']
      }, labelProps),
      end: _babelRuntimeHelpersExtends({
        UNSAFE_className: $bfbcd6bc836614813c70085787fd$$interop$default['spectrum-Menu-end']
      }, descriptionProps),
      icon: {
        UNSAFE_className: $bfbcd6bc836614813c70085787fd$$interop$default['spectrum-Menu-icon'],
        size: 'S'
      },
      description: _babelRuntimeHelpersExtends({
        UNSAFE_className: $bfbcd6bc836614813c70085787fd$$interop$default['spectrum-Menu-description']
      }, descriptionProps),
      keyboard: _babelRuntimeHelpersExtends({
        UNSAFE_className: $bfbcd6bc836614813c70085787fd$$interop$default['spectrum-Menu-keyboard']
      }, keyboardShortcutProps)
    }
  }, contents, isSelected && /*#__PURE__*/_react.createElement(_spectrumIconsUiCheckmarkMedium, {
    slot: "checkmark",
    UNSAFE_className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu-checkmark')
  }))))));
}

/** @private */
function $c0ff64d7a4e982f233f34aa6c4a1bc$export$MenuSection(props) {
  let {
    item,
    state,
    onAction
  } = props;
  let {
    itemProps,
    headingProps,
    groupProps
  } = useMenuSection({
    heading: item.rendered,
    'aria-label': item['aria-label']
  });
  let {
    separatorProps
  } = useSeparator({
    elementType: 'li'
  });
  return /*#__PURE__*/_react.createElement(Fragment, null, item.key !== state.collection.getFirstKey() && /*#__PURE__*/_react.createElement("li", _babelRuntimeHelpersExtends({}, separatorProps, {
    className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu-divider')
  })), /*#__PURE__*/_react.createElement("li", itemProps, item.rendered && /*#__PURE__*/_react.createElement("span", _babelRuntimeHelpersExtends({}, headingProps, {
    className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu-sectionHeading')
  }), item.rendered), /*#__PURE__*/_react.createElement("ul", _babelRuntimeHelpersExtends({}, groupProps, {
    className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu')
  }), [...item.childNodes].map(node => {
    let item = /*#__PURE__*/_react.createElement($c7f2f7472da9591348da844617ffa5d9$export$MenuItem, {
      key: node.key,
      item: node,
      state: state,
      onAction: onAction
    });

    if (node.wrapper) {
      item = node.wrapper(item);
    }

    return item;
  }))));
}

function $be3a5c916828e33faf8ffa30483fbe6$var$Menu(props, ref) {
  let contextProps = useContext($edd9ab002cde8b9b98bf7ac7e2372c8e$export$MenuContext);

  let completeProps = _babelRuntimeHelpersExtends({}, mergeProps(contextProps, props));

  let domRef = useDOMRef(ref);
  let state = useTreeState(completeProps);
  let {
    menuProps
  } = useMenu(completeProps, state, domRef);
  let {
    styleProps
  } = useStyleProps(completeProps);
  useSyncRef(contextProps, domRef);
  return /*#__PURE__*/_react.createElement("ul", _babelRuntimeHelpersExtends({}, menuProps, styleProps, {
    ref: domRef,
    className: classNames($bfbcd6bc836614813c70085787fd$$interop$default, 'spectrum-Menu', styleProps.className)
  }), [...state.collection].map(item => {
    if (item.type === 'section') {
      return /*#__PURE__*/_react.createElement($c0ff64d7a4e982f233f34aa6c4a1bc$export$MenuSection, {
        key: item.key,
        item: item,
        state: state,
        onAction: completeProps.onAction
      });
    }

    let menuItem = /*#__PURE__*/_react.createElement($c7f2f7472da9591348da844617ffa5d9$export$MenuItem, {
      key: item.key,
      item: item,
      state: state,
      onAction: completeProps.onAction
    });

    if (item.wrapper) {
      menuItem = item.wrapper(menuItem);
    }

    return menuItem;
  }));
}
/**
 * Menus display a list of actions or options that a user can choose.
 */
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref


const Menu = /*#__PURE__*/_react.forwardRef($be3a5c916828e33faf8ffa30483fbe6$var$Menu);

exports.Menu = Menu;
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/ar-AE.json
var $eafe6f0486baa2a496a149d08400$exports = {};
$eafe6f0486baa2a496a149d08400$exports = JSON.parse("{\"moreActions\":\"المزيد من الإجراءات\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/bg-BG.json
var $fb02048fb547c2028f437529309b4429$exports = {};
$fb02048fb547c2028f437529309b4429$exports = JSON.parse("{\"moreActions\":\"Повече действия\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/cs-CZ.json
var $b0768be3cfb21e7fced837bd2566b5$exports = {};
$b0768be3cfb21e7fced837bd2566b5$exports = JSON.parse("{\"moreActions\":\"Další akce\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/da-DK.json
var $c09675fc574e1dfc6bafe9f9c80936d$exports = {};
$c09675fc574e1dfc6bafe9f9c80936d$exports = JSON.parse("{\"moreActions\":\"Flere handlinger\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/de-DE.json
var $e907c81edb8d0faf0fa461a433506b9f$exports = {};
$e907c81edb8d0faf0fa461a433506b9f$exports = JSON.parse("{\"moreActions\":\"Mehr Aktionen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/el-GR.json
var $dd809d3c59848c3c16cd04026520896$exports = {};
$dd809d3c59848c3c16cd04026520896$exports = JSON.parse("{\"moreActions\":\"Περισσότερες ενέργειες\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/en-US.json
var $ac1c322dbf5443c2cc13a252ec559a6e$exports = {};
$ac1c322dbf5443c2cc13a252ec559a6e$exports = JSON.parse("{\"moreActions\":\"More actions\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/es-ES.json
var $fab88d44a5a6b836096f7a400fafbc42$exports = {};
$fab88d44a5a6b836096f7a400fafbc42$exports = JSON.parse("{\"moreActions\":\"Más acciones\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/et-EE.json
var $ce4a78d7966e38ba583bc5e6bd0a0cb$exports = {};
$ce4a78d7966e38ba583bc5e6bd0a0cb$exports = JSON.parse("{\"moreActions\":\"Veel toiminguid\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/fi-FI.json
var $ffd9855f5d348fd94616deba716bca0b$exports = {};
$ffd9855f5d348fd94616deba716bca0b$exports = JSON.parse("{\"moreActions\":\"Lisää toimintoja\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/fr-FR.json
var $b3e70a50559ed1ca87a7e3ab$exports = {};
$b3e70a50559ed1ca87a7e3ab$exports = JSON.parse("{\"moreActions\":\"Autres actions\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/he-IL.json
var $ef844e91acc4f30ae70d7aaae080e93$exports = {};
$ef844e91acc4f30ae70d7aaae080e93$exports = JSON.parse("{\"moreActions\":\"פעולות נוספות\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/hr-HR.json
var $f072be949ce813802a8d50d933ade2da$exports = {};
$f072be949ce813802a8d50d933ade2da$exports = JSON.parse("{\"moreActions\":\"Dodatne radnje\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/hu-HU.json
var $ef3bff926d0b403e6b9752784df9b345$exports = {};
$ef3bff926d0b403e6b9752784df9b345$exports = JSON.parse("{\"moreActions\":\"További lehetőségek\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/it-IT.json
var $d8dbd9aead9357b46597031d77a$exports = {};
$d8dbd9aead9357b46597031d77a$exports = JSON.parse("{\"moreActions\":\"Altre azioni\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/ja-JP.json
var $d51e7578ce8666eec63d407a99254e47$exports = {};
$d51e7578ce8666eec63d407a99254e47$exports = JSON.parse("{\"moreActions\":\"その他のアクション\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/ko-KR.json
var $aa54b674da588a75bb2474e8f608104b$exports = {};
$aa54b674da588a75bb2474e8f608104b$exports = JSON.parse("{\"moreActions\":\"기타 작업\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/lt-LT.json
var $ff785f8a1d2c4412711652da47bc4fd$exports = {};
$ff785f8a1d2c4412711652da47bc4fd$exports = JSON.parse("{\"moreActions\":\"Daugiau veiksmų\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/lv-LV.json
var $cc17e033cdafb87e2439945761eda141$exports = {};
$cc17e033cdafb87e2439945761eda141$exports = JSON.parse("{\"moreActions\":\"Citas darbības\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/nb-NO.json
var $a880a96e1287100a0b133dd2c299$exports = {};
$a880a96e1287100a0b133dd2c299$exports = JSON.parse("{\"moreActions\":\"Flere handlinger\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/nl-NL.json
var $abedef01978bfd8c033b14a757091a$exports = {};
$abedef01978bfd8c033b14a757091a$exports = JSON.parse("{\"moreActions\":\"Meer handelingen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/pl-PL.json
var $e02225efb37e7469bc2910764718f928$exports = {};
$e02225efb37e7469bc2910764718f928$exports = JSON.parse("{\"moreActions\":\"Więcej akcji\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/pt-BR.json
var $ba0e82c9bf597ae340552a05650e246a$exports = {};
$ba0e82c9bf597ae340552a05650e246a$exports = JSON.parse("{\"moreActions\":\"Mais ações\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/pt-PT.json
var $f5565aa000fa977bffe84e879ac5ea$exports = {};
$f5565aa000fa977bffe84e879ac5ea$exports = JSON.parse("{\"moreActions\":\"Mais ações\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/ro-RO.json
var $c23c6ed2d5acf7448c161f5a5e01968$exports = {};
$c23c6ed2d5acf7448c161f5a5e01968$exports = JSON.parse("{\"moreActions\":\"Mai multe acțiuni\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/ru-RU.json
var $e5789ba03f5554a86e5e5cdbd40ec0f0$exports = {};
$e5789ba03f5554a86e5e5cdbd40ec0f0$exports = JSON.parse("{\"moreActions\":\"Дополнительные действия\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/sk-SK.json
var $b4120cd58100bed5ddb7f16ee836e96b$exports = {};
$b4120cd58100bed5ddb7f16ee836e96b$exports = JSON.parse("{\"moreActions\":\"Ďalšie akcie\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/sl-SI.json
var $a309506e7037d753a27edbeba117146e$exports = {};
$a309506e7037d753a27edbeba117146e$exports = JSON.parse("{\"moreActions\":\"Več možnosti\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/sr-SP.json
var $bae5726091c435f027ed74f38ef29ee$exports = {};
$bae5726091c435f027ed74f38ef29ee$exports = JSON.parse("{\"moreActions\":\"Dodatne radnje\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/sv-SE.json
var $f339c61a14454787ea218190a467596e$exports = {};
$f339c61a14454787ea218190a467596e$exports = JSON.parse("{\"moreActions\":\"Fler åtgärder\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/tr-TR.json
var $d1e0e0442f7b26623ac4344eb385b045$exports = {};
$d1e0e0442f7b26623ac4344eb385b045$exports = JSON.parse("{\"moreActions\":\"Daha fazla eylem\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/uk-UA.json
var $e0271d05c99c5c8dbbece3c098c14ba$exports = {};
$e0271d05c99c5c8dbbece3c098c14ba$exports = JSON.parse("{\"moreActions\":\"Більше дій\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/zh-CN.json
var $acec37a2bd758dae462e2a7833f827b$exports = {};
$acec37a2bd758dae462e2a7833f827b$exports = JSON.parse("{\"moreActions\":\"更多操作\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/menu/intl/zh-TW.json
var $df8ada29778100ef6397abb2a019377$exports = {};
$df8ada29778100ef6397abb2a019377$exports = JSON.parse("{\"moreActions\":\"更多動作\"}");
// @ts-ignore
const $cab3a409b2fc0adfc79ffc670f9418$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($eafe6f0486baa2a496a149d08400$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($fb02048fb547c2028f437529309b4429$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($b0768be3cfb21e7fced837bd2566b5$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($c09675fc574e1dfc6bafe9f9c80936d$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($e907c81edb8d0faf0fa461a433506b9f$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($dd809d3c59848c3c16cd04026520896$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($ac1c322dbf5443c2cc13a252ec559a6e$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($fab88d44a5a6b836096f7a400fafbc42$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($ce4a78d7966e38ba583bc5e6bd0a0cb$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($ffd9855f5d348fd94616deba716bca0b$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($b3e70a50559ed1ca87a7e3ab$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($ef844e91acc4f30ae70d7aaae080e93$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($f072be949ce813802a8d50d933ade2da$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($ef3bff926d0b403e6b9752784df9b345$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($d8dbd9aead9357b46597031d77a$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($d51e7578ce8666eec63d407a99254e47$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($aa54b674da588a75bb2474e8f608104b$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($ff785f8a1d2c4412711652da47bc4fd$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($cc17e033cdafb87e2439945761eda141$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($a880a96e1287100a0b133dd2c299$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($abedef01978bfd8c033b14a757091a$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($e02225efb37e7469bc2910764718f928$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($ba0e82c9bf597ae340552a05650e246a$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($f5565aa000fa977bffe84e879ac5ea$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($c23c6ed2d5acf7448c161f5a5e01968$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($e5789ba03f5554a86e5e5cdbd40ec0f0$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($b4120cd58100bed5ddb7f16ee836e96b$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($a309506e7037d753a27edbeba117146e$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($bae5726091c435f027ed74f38ef29ee$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($f339c61a14454787ea218190a467596e$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($d1e0e0442f7b26623ac4344eb385b045$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($e0271d05c99c5c8dbbece3c098c14ba$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($acec37a2bd758dae462e2a7833f827b$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($df8ada29778100ef6397abb2a019377$exports).default
};

function $cab3a409b2fc0adfc79ffc670f9418$var$ActionMenu(props, ref) {
  props = useSlotProps(props, 'actionmenu');
  let formatMessage = useMessageFormatter($cab3a409b2fc0adfc79ffc670f9418$var$intlMessages);
  let buttonProps = filterDOMProps(props, {
    labelable: true
  });

  if (buttonProps['aria-label'] === undefined) {
    buttonProps['aria-label'] = formatMessage('moreActions');
  }

  return /*#__PURE__*/_react.createElement(MenuTrigger, {
    isOpen: props.isOpen,
    align: props.align,
    direction: props.direction,
    shouldFlip: props.shouldFlip
  }, /*#__PURE__*/_react.createElement(ActionButton, _babelRuntimeHelpersExtends({
    ref: ref
  }, props, buttonProps), /*#__PURE__*/_react.createElement(_spectrumIconsWorkflowMore, null)), /*#__PURE__*/_react.createElement(Menu, {
    children: props.children,
    items: props.items,
    disabledKeys: props.disabledKeys,
    onAction: props.onAction
  }));
}
/**
 * Convenience component to display an ActionButton with a Menu.
 */


let ActionMenu = /*#__PURE__*/_react.forwardRef($cab3a409b2fc0adfc79ffc670f9418$var$ActionMenu);

exports.ActionMenu = ActionMenu;
